(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("angular"), require("angular-animate"));
	else if(typeof define === 'function' && define.amd)
		define("angularjs-bootstrap-4", ["angular", "angular-animate"], factory);
	else if(typeof exports === 'object')
		exports["angularjs-bootstrap-4"] = factory(require("angular"), require("angular-animate"));
	else
		root["angularjs-bootstrap-4"] = factory(root["angular"], root["angular-animate"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE_angular__, __WEBPACK_EXTERNAL_MODULE_angular_animate__) {
return 